import { Center, Image, Text } from "@chakra-ui/react"
import PREVIEW_IMAGE from "@hydrologiq/customers/assets/images/forecast.png"

function Forecast() {
  return (
    <Center>
      <Text
        position="relative"
        top={"-315px"}
        left={"50%"}
        color="rgba(0, 0, 0, 0.33)"
        fontSize="2xl"
        fontWeight="bold"
      >
        Preview
      </Text>
      <Image src={PREVIEW_IMAGE} alt="Forecast preview" w="90%" h="80vh" objectFit="fill" />
    </Center>
  )
}

export default Forecast
